import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi, OperatoriApi, PuntiDiRaccoltaApi, TenantsApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { LoadPanel, Lookup } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { on } from 'events';
import { showError } from '../../utils/errorHandling';
import ComuneSelector, { ILocation } from '../comuneSelector/ComuneSelector';
import notify from 'devextreme/ui/notify';
import { isUndefined } from 'util';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
// import { useComuniDataSource } from '../../datasources/ComuniDataSource'; //todo: RGAM non esiste più datasource comuni.

type Props = {
  tenantId?: string;
  onchanged?: () => void;
}

export type TenantEditPanelHandle = {
  save: () => Promise<boolean>;
}

const TenantEditPanel: React.ForwardRefRenderFunction<TenantEditPanelHandle, Props> = (props, ref) => {
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();
  const formRef = useRef<FormRef>(null);

  useEffect(() => {
    // console.log("TenantEditPanel useEffect", props.tenantId);
    setFormData(undefined);

    (async function () {
      const api = new TenantsApi(apiConfiguration);
      setLoadPanelVisible(true);

      var data;
      if (props.tenantId) {
        setFormData(await api.getTenantAnagraficaById({ tenantId: props.tenantId }));
      }
      else {
        setFormData({});
      }

      setLoadPanelVisible(false);
    })();

  }, [props.tenantId]);

  useImperativeHandle(ref, () => ({
    async save() {
      var validate = formRef.current?.instance().validate();

      if (validate?.isValid) {
        const api = new TenantsApi(apiConfiguration);

        var data = formRef.current?.instance().option("formData");

        setLoadPanelVisible(true);

        try {
          if (props.tenantId) {
            await api.updateTenantAnagraficaById({
              tenantId: props.tenantId,
              tenantAnagraficaUpdateDTO: data
            });

            props.onchanged?.();

            return true;
          }
          else
            throw "Tenant anagrafica non esistente";
        }
        catch (e) {
          showError(e);
          return false;
        }
        finally {
          setLoadPanelVisible(false);
        }

      }
      else {
        notify("Correggere gli errori di validazione", "error", 2000);
        return false;
      }
    }
  }));

  return (
    <React.Fragment>

      <Form id="form" ref={formRef} colCount={3} formData={formData} labelMode='floating' onFieldDataChanged={props.onchanged} disabled={loadPanelVisible}>

        <Item dataField="nome" isRequired={true} colSpan={3} />

        <GroupItem caption="Localizzazione" colSpan={3} colCount={4}>
          <SimpleItem
            colSpan={4}
            render={(e) =>
              <ComuneSelector
                data={{
                  nazioneId: formData?.nazioneId,
                  regioneId: formData?.regioneId,
                  provinciaId: formData?.provinciaId,
                  comuneId: formData?.comuneId,
                  regione: formData?.regione,
                  provincia: formData?.provincia,
                  comune: formData?.comune
                }}
                onValueChanged={(data) => {
                  e?.component.updateData("comuneId", data.comuneId);
                  e?.component.updateData("provinciaId", data.provinciaId);
                  e?.component.updateData("regioneId", data.regioneId);
                  e?.component.updateData("nazioneId", data.nazioneId);
                  e?.component.updateData("comune", data.comune);
                  e?.component.updateData("provincia", data.provincia);
                  e?.component.updateData("regione", data.regione);
                }}
              />
            }
          />
          <Item dataField="localita" caption='Località' />
          <Item dataField="indirizzo" colSpan={2} />
          <GroupItem colSpan={1} colCount={2}>
            <Item dataField="numeroCivico" />
            <Item dataField="cap" />
          </GroupItem>
        </GroupItem>
        {/* 
        <GroupItem caption="Contatti" colSpan={3} colCount={3}>
          <Item dataField="email" />
          <Item dataField="telefono" />
          <Item dataField="cellulare" />
        </GroupItem> */}

        <SimpleItem dataField="note" colSpan={3} editorType="dxTextArea" editorOptions={{ height: 80 }} />


        {/*  */}
      </Form>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>
  );
}

export default React.forwardRef(TenantEditPanel);